// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"muiButton_iconWrapper__eEw-x"};